import { __extends } from "tslib";
import { ASObject, axCoerceString } from '@awayfl/avm2';
import { Debug } from '@awayjs/core';
var TabStop = /** @class */ (function (_super) {
    __extends(TabStop, _super);
    function TabStop(alignment, position, decimalAlignmentToken) {
        if (alignment === void 0) { alignment = 'start'; }
        if (position === void 0) { position = 0; }
        if (decimalAlignmentToken === void 0) { decimalAlignmentToken = ''; }
        alignment = axCoerceString(alignment);
        position = +position;
        decimalAlignmentToken = axCoerceString(decimalAlignmentToken);
        return _super.call(this) || this;
    }
    Object.defineProperty(TabStop.prototype, "alignment", {
        // JS -> AS Bindings
        // AS -> JS Bindings
        // _alignment: string;
        // _position: number;
        // _decimalAlignmentToken: string;
        get: function () {
            // @todo
            Debug.throwPIR('playerglobals/text/engine/TabStop', 'get alignment', '');
            return;
        },
        set: function (value) {
            value = axCoerceString(value);
            // @todo
            Debug.throwPIR('playerglobals/text/engine/TabStop', 'set alignment', '');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TabStop.prototype, "position", {
        get: function () {
            // @todo
            Debug.throwPIR('playerglobals/text/engine/TabStop', 'get position', '');
            return;
        },
        set: function (value) {
            value = +value;
            // @todo
            Debug.throwPIR('playerglobals/text/engine/TabStop', 'set position', '');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TabStop.prototype, "decimalAlignmentToken", {
        get: function () {
            // @todo
            Debug.throwPIR('playerglobals/text/engine/TabStop', 'get decimalAlignmentToken', '');
            return;
        },
        set: function (value) {
            value = axCoerceString(value);
            // @todo
            Debug.throwPIR('playerglobals/text/engine/TabStop', 'set decimalAlignmentToken', '');
        },
        enumerable: false,
        configurable: true
    });
    TabStop.forceNativeConstructor = true;
    TabStop.forceNativeMethods = true;
    return TabStop;
}(ASObject));
export { TabStop };
